import {Pipe, PipeTransform} from '@angular/core';
import {ScheduleTypeInternal} from "../../core/interfaces/core.types";

@Pipe({
  standalone: true,
  name: 'iconDisplay'
})
export class IconDisplayPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    switch (value) {
      case ScheduleTypeInternal.bookings:
        // return '<i class="pi pi-calendar-plus text-white text-2xl"></i>';
        return '<img src="../../../assets/images/ob-calendar.svg" alt="Bookings">'
      case ScheduleTypeInternal.whatsapp:
        return '<img src="../../../assets/images/ob-whatsapp.svg" alt="whatsapp">'
        // return `<i class="pi pi-whatsapp text-white text-2xl"></i>`;
      case ScheduleTypeInternal.call_me_back:
        // return '<i class="pi pi-phone text-white text-2xl"></i>';
        return '<img src="../../../assets/images/ob-mobile.svg" alt="Call me back">'
      case ScheduleTypeInternal.call_us:
        // return '<i class="pi pi-phone text-white text-2xl"></i>';
        return '<img src="../../../assets/images/ob-phone.svg" alt="call_us">'
      case ScheduleTypeInternal.none:
        // return '<i class="pi pi-calendar-plus text-white text-2xl"></i>';
        return '<img src="../../../assets/images/ob-home.svg" alt="Later">'
      case ScheduleTypeInternal.vcard_qr:
        return '<i class="pi pi-id-card text-white text-2xl"></i>';

      default:
        return value;
    }
  }

}


/*
      case ScheduleTypeInternal.whatsapp:
        return 'bg-green-500';
      case ScheduleTypeInternal.call_me_back:
        return 'bg-blue-500';
      case ScheduleTypeInternal.call_us:
        return 'bg-cyan-500';
      case ScheduleTypeInternal.bookings:
        return 'bg-indigo-500';
      case ScheduleTypeInternal.none:
 */
